import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { parseIsoDateOrTimestamp } from '../../../../Timestamp/functions';
import { getIsAdoptableOfferType } from '../../../../utils/adoptables';
import s from './AdoptableCardStats.scss';
/**
 * Tells us if an adoptable has never entered its offer window
 */ export function getIsBeforeOfferWindow(deviation) {
    var _deviation_adoptable;
    const { offers = {}, thumbSaleState } = (_deviation_adoptable = deviation.adoptable) !== null && _deviation_adoptable !== void 0 ? _deviation_adoptable : {};
    const { offerEndTime } = offers;
    // thumbSaleState is specific to shop thumbs.
    // TODO: If we use this function outside of thumbs, we need to talk to backend about an alternative.
    return offerEndTime === undefined && thumbSaleState === 'open';
}
const AdoptableCardStats = ({ deviation })=>{
    var _deviation_adoptable, _deviation_adoptable1;
    const { t } = useTranslation();
    const isOfferType = getIsAdoptableOfferType(deviation);
    const { numOffers, offerEndTime } = ((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.offers) || {};
    const thumbSaleState = ((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : _deviation_adoptable1.thumbSaleState) || '';
    const toDate = parseIsoDateOrTimestamp(offerEndTime);
    // We want time-left to be the number of full hours remaining, until we
    // reach the last hour; then we want full _and partial_ minutes so we
    // don't show Time's Up early
    const hoursLeft = useMemo(()=>{
        const MS_PER_HOUR = 1000 * 3600;
        return Math.floor((toDate.getTime() - Date.now()) / MS_PER_HOUR);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const minsLeft = useMemo(()=>{
        const MS_PER_MIN = 1000 * 60;
        return Math.ceil((toDate.getTime() - Date.now()) / MS_PER_MIN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ([
        'sold',
        'unlisted',
        'expired'
    ].includes(thumbSaleState)) {
        return null;
    }
    // We'll show a CTA if this is adoptable is open to offers and the offer window hasn't started yet
    if (isOfferType && getIsBeforeOfferWindow(deviation)) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement("span", null, t('shop.thumb.adoptable.cta')));
    }
    const timesUp = toDate.getTime() < Date.now();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, minsLeft >= 60 && /*#__PURE__*/ React.createElement("span", null, t('shop.thumb.adoptable.hoursLeft', {
        count: hoursLeft
    })), minsLeft < 60 && minsLeft > 0 && /*#__PURE__*/ React.createElement("span", {
        className: s['warning']
    }, t('shop.thumb.adoptable.minsLeft', {
        count: minsLeft
    })), timesUp && /*#__PURE__*/ React.createElement("span", {
        className: s['warning']
    }, t('shop.thumb.adoptable.timesUp')), !!numOffers && /*#__PURE__*/ React.createElement("span", null, t('common.offerCount', {
        count: numOffers
    })));
};
AdoptableCardStats.displayName = 'AdoptableCardStats';
export default AdoptableCardStats;
